<template>
    <div class="zone-title zone-title--bg banded landing__zone-title--short">
        <div class="zone-title__foreground foreground">
            <div class="container-title container-headline container-headline--no-image">
                <h2>{{ pageData.data.title }}</h2>
                <RichTextElements :elements="pageData.data.dek" class="interactive-dek" bodyStyle="serif-large" />
            </div>
        </div>
    </div>
    <div class="section">
        <div class="filters">
            <div class="title">
                <span>Countries using AI surveillance technology</span>
            </div>
            <form class="clean-form surveillance-radio toggle-wrapper padded-less" name="surveillance-radio"
                id="surveillance-radio" action="" method="get" enctype="multipart/form-data" autocomplete="off">
                <fieldset>
                    <div class="control-group">
                        <label class="pub-type-label" id="smartCity">
                            <span class="name">Smart City</span>
                            <input class="checkradios" type="radio" value="city" name="radio-group" id="radio-city"
                                @click="changeButtonOnClick($event)">
                        </label>
                        <label class="pub-type-label" id="facialRecognition">
                            <span class="name">Facial Recognition</span>
                            <input class="checkradios" type="radio" value="facial" name="radio-group" id="radio-facial"
                                @click="changeButtonOnClick($event)">
                        </label>
                        <label class="pub-type-label" id="smartPolicing">
                            <span class="name">Smart Policing</span>
                            <input class="checkradios" type="radio" value="police" name="radio-group" id="radio-police"
                                @click="changeButtonOnClick($event)">
                        </label>
                        <label class="pub-type-label" id="USTech">
                            <span class="name">U.S. Tech</span>
                            <input class="checkradios" type="radio" value="us" name="radio-group" id="radio-us"
                                @click="changeButtonOnClick($event)">
                        </label>
                        <label class="pub-type-label" id="ChineseTech">
                            <span class="name">Chinese Tech</span>
                            <input class="checkradios" type="radio" value="chinese" name="radio-group" id="radio-chinese"
                                @click="changeButtonOnClick($event)">
                        </label>
                        <label class="pub-type-label reset">
                            <span class="name">Reset</span>
                            <input class="checkradios" type="radio" value="all" name="radio-group" id="radio-all"
                                @click="changeButtonOnClick($event)">
                        </label>
                    </div>
                </fieldset>
            </form>
        </div>
        <div class="section map">
            <div id="chartdiv"></div>
            <div id="info"></div>
            <div id="countrySelect">
                <form class="clean-form surveillance-dropdown" name="surveillance-dropdown" id="surveillance-dropdown"
                    action="" method="get" enctype="multipart/form-data" autocomplete="off">
                    <select name="surveillance-countries" id="surveillance-countries">
                        <option value="reset">Select Country</option>
                        <option value="DZ">Algeria</option>
                        <option value="AR">Argentina</option>
                        <option value="AM">Armenia</option>
                        <option value="AU">Australia</option>
                        <option value="BH">Bahrain</option>
                        <option value="BD">Bangladesh</option>
                        <option value="BO">Bolivia</option>
                        <option value="BW">Botswana</option>
                        <option value="BR">Brazil</option>
                        <option value="MM">Burma</option>
                        <option value="CA">Canada</option>
                        <option value="CL">Chile</option>
                        <option value="CN">China</option>
                        <option value="CO">Colombia</option>
                        <option value="CZ">Czechia</option>
                        <option value="DK">Denmark</option>
                        <option value="EC">Ecuador</option>
                        <option value="EG">Egypt</option>
                        <option value="FR">France</option>
                        <option value="GE">Georgia</option>
                        <option value="DE">Germany</option>
                        <option value="GH">Ghana</option>
                        <option value="HK">Hong Kong</option>
                        <option value="IN">India</option>
                        <option value="ID">Indonesia</option>
                        <option value="IR">Iran</option>
                        <option value="IQ">Iraq</option>
                        <option value="IL">Israel</option>
                        <option value="IT">Italy</option>
                        <option value="CI">Ivory Coast</option>
                        <option value="JP">Japan</option>
                        <option value="KZ">Kazakhstan</option>
                        <option value="KE">Kenya</option>
                        <option value="KG">Kyrgyzstan</option>
                        <option value="LA">Laos</option>
                        <option value="LB">Lebanon</option>
                        <option value="MY">Malaysia</option>
                        <option value="MT">Malta</option>
                        <option value="MU">Mauritius</option>
                        <option value="MX">Mexico</option>
                        <option value="MN">Mongolia</option>
                        <option value="MA">Morocco</option>
                        <option value="NA">Namibia</option>
                        <option value="NL">Netherlands</option>
                        <option value="NZ">New Zealand</option>
                        <option value="NG">Nigeria</option>
                        <option value="OM">Oman</option>
                        <option value="PK">Pakistan</option>
                        <option value="PA">Panama</option>
                        <option value="PH">Philippines</option>
                        <option value="QA">Qatar</option>
                        <option value="RO">Romania</option>
                        <option value="RU">Russia</option>
                        <option value="RW">Rwanda</option>
                        <option value="SA">Saudi Arabia</option>
                        <option value="RS">Serbia</option>
                        <option value="SG">Singapore</option>
                        <option value="ZA">South Africa</option>
                        <option value="KR">South Korea</option>
                        <option value="ES">Spain</option>
                        <option value="CH">Switzerland</option>
                        <option value="TW">Taiwan</option>
                        <option value="TJ">Tajikistan</option>
                        <option value="TH">Thailand</option>
                        <option value="TR">Turkey</option>
                        <option value="UG">Uganda</option>
                        <option value="UA">Ukraine</option>
                        <option value="AE">United Arab Emirates</option>
                        <option value="GB">United Kingdom</option>
                        <option value="US">United States of America</option>
                        <option value="UY">Uruguay</option>
                        <option value="UZ">Uzbekistan</option>
                        <option value="VE">Venezuela</option>
                        <option value="ZM">Zambia</option>
                        <option value="ZW">Zimbabwe</option>
                    </select>
                </form>
            </div>
        </div>
    </div>
    <div class="section">
        <div class="foreground">
            <div class="learn-more">
                <p>To provide greater clarity, Carnegie presents an AI Global Surveillance (AIGS) Index—representing one of
                    the first research efforts of its kind. The index compiles empirical data on AI surveillance use for 176
                    countries around the world. It does not distinguish between legitimate and unlawful uses of AI
                    surveillance. Rather, the purpose of the research is to show how new surveillance capabilities are
                    transforming the ability of governments to monitor and track individuals or systems. It specifically
                    asks:</p>
                <ul>
                    <li>Which countries are adopting AI surveillance technology?</li>
                    <li>What specific types of AI surveillance are governments deploying?</li>
                    <li>Which countries and companies are supplying this technology?</li>
                </ul>
                <p><a href="https://carnegieendowment.org/p-79847" target="_blank">Learn more</a> about our findings and how
                    AI surveillance technology is spreading rapidly around the globe.</p>
                <div class="center">
                    <a class="button-big" href="https://carnegieendowment.org/p-79847" target="_blank">Learn More</a>
                </div>
                <h4>Notes</h4>
                <p>Aggregate Regime Score: Comprised of evenly weighted average of country scores from Freedom in the World
                    2019, <a
                        href="https://freedomhouse.org/report/countries-world-freedom-2019">https://freedomhouse.org/report/countries-world-freedom-2019</a>;
                    the EIU Democracy Index 2018, <a
                        href="https://www.eiu.com/topic/democracy-index">https://www.eiu.com/topic/democracy-index</a>; and
                    the V-Dem Dataset version 9, Electoral Democracy Index, <a
                        href="https://www.v-dem.net/en/data/data-version-9/">https://www.v-dem.net/en/data/data-version-9/</a>.
                </p>
                <p>Regime Type: The AIGS Index uses a four-part regime category typology established by V-Dem and Regimes of
                    the World: closed autocracies, electoral autocracies, electoral democracies, and liberal democracies.
                    Countries with an average score less than 2.5 are labeled closed autocracies. Countries with an average
                    score between 4.9 and 2.5 are labeled electoral autocracies. Countries with an average score between 7.9
                    and 5.0 are labeled electoral democracies. Countries with an average score of 8 or higher are labeled
                    liberal democracies. See Anna Lührmann, Marcus Tannenberg, and Staffan I. Lindberg, “Regimes of the
                    World (RoW): Opening New Avenues for the Comparative Study of Political Regimes,” Politics &amp;
                    Governance 6, no. 1 (2018).</p>
                <p>“Freedom on the Net 2018” data can be accessed at <a
                        href="https://freedomhouse.org/report/freedom-net/freedom-net-2018">https://freedomhouse.org/report/freedom-net/freedom-net-2018</a>.
                </p>
                <p>Military expenditure data compiled by the Stockholm International Peace Research Institute and can be
                    accessed at <a href="https://www.sipri.org/databases/milex">https://www.sipri.org/databases/milex</a>.
                </p>
                <p>Data on Belt and Road Initiative participating countries compiled from Dan Kliman and Abigail Grace’s
                    report, “Power Play: Addressing China’s Belt and Road Strategy,” Center for a New American Security,
                    2018, <a
                        href="https://s3.amazonaws.com/files.cnas.org/documents/CNASReport-Power-Play-Addressing-Chinas-Belt-and-Road-Strategy.pdf?mtime=20180920093003">https://s3.amazonaws.com/files.cnas.org/documents/CNASReport-Power-Play-Addressing-Chinas-Belt-and-Road-Strategy.pdf?mtime=20180920093003</a>,
                    as well as from open source reporting.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
useHead({
    script: [
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/index.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/map.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/geodata/worldLow.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/themes/Animated.js' }
    ]
});
import { onMounted, ref } from 'vue';
import FeatureFragment from '@fragments/pages/FeatureFragment';

const pageData = await usePageData(FeatureFragment);

var usedDataArray;

// anything that needs the DOM to exist (like calling document or window) has to be called here
var trackedCountry = "#072a42";
var activeCountry = "#000000";
var activeCountrySmartCity = "#EF4136";
var activeCountryFacialRecognition = "#00AEEF";
var activeCountrySmartPolicing = "#FBB042";
var activeCountryUSTech = "#81215F";
var activeCountryChinaTech = "#00A79D";
var clickedCountry = "#000000";

onMounted(() => {
    trackedCountry = am5.color(0x072a42);
    activeCountry = am5.color(0x000000);
    activeCountrySmartCity = am5.color(0xEF4136);
    activeCountryFacialRecognition = am5.color(0x00AEEF);
    activeCountrySmartPolicing = am5.color(0xFBB042);
    activeCountryUSTech = am5.color(0x81215F);
    activeCountryChinaTech = am5.color(0x00A79D);
    clickedCountry = am5.color(0x000000);
    callMap();
});

var dataArray = [
    {
        id: "DZ",
        arrayItem: true,
        country: 'Algeria',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>25</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>BAE, Huawei</strong></p></div>",
        policing: true,
        chinese: true,
        mapData: {
            "id": "DZ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "DZ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "AR",
        arrayItem: true,
        country: 'Argentina',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>43</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Axis, Bosch, Dahua, Huawei, NEC, ZTE</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "AR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "AR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "AM",
        arrayItem: true,
        country: 'Armenia',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>81</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "AM",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "AM",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "AU",
        arrayItem: true,
        country: 'Australia',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>13</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>CrowdOptic, Hikvision, Huawei, Infinova, NEC, Palantir</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "AU",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "AU",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "BH",
        arrayItem: true,
        country: 'Bahrain',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>65</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Dahua</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "BH",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "BH",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "BD",
        arrayItem: true,
        country: 'Bangladesh',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>44</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "BD",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "BD",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "BO",
        arrayItem: true,
        country: 'Bolivia',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>79</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>CEIEC, Huawei, ZTE</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "BO",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "BO",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "BW",
        arrayItem: true,
        country: 'Botswana',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>86</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "BW",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "BW",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "BR",
        arrayItem: true,
        country: 'Brazil',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>12</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Axis, Dahua, IBM</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "BR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "BR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MM",
        arrayItem: true,
        country: 'Burma',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>58</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "MM",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MM",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CA",
        arrayItem: true,
        country: 'Canada',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>14</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Avigilon, Palantir</strong></p></div>",
        facial: true,
        policing: true,
        us: true,
        mapData: {
            "id": "CA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CL",
        arrayItem: true,
        country: 'Chile',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>34</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "CL",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CL",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CN",
        arrayItem: true,
        country: 'China',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>2</strong></p><p>China Belt and Road Initiative: <strong>N/A</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Mult; Axis, Bosch, IBM, Microsoft, Seagate, Qualcomm</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "CN",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CN",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CO",
        arrayItem: true,
        country: 'Colombia',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>24</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>NEC</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        mapData: {
            "id": "CO",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CO",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CZ",
        arrayItem: true,
        country: 'Czechia',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>53</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>N/A</strong></p></div>",
        facial: true,
        policing: true,
        mapData: {
            "id": "CZ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CZ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "DK",
        arrayItem: true,
        country: 'Denmark',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>42</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Avigilon, BrainChip, Cisco, Hikvision, Palantir</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "DK",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "DK",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "EC",
        arrayItem: true,
        country: 'Ecuador',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>55</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>CEIEC, Cisco, Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "EC",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "EC",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "EG",
        arrayItem: true,
        country: 'Egypt',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>51</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Honeywell, Huawei</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "EG",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "EG",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "FR",
        arrayItem: true,
        country: 'France',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>5</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, Huawei, Palantir, Teleste, Thales, ZTE</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "FR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "FR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "GE",
        arrayItem: true,
        country: 'Georgia',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>100</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>NEC</strong></p></div>",
        facial: true,
        policing: true,
        mapData: {
            "id": "GE",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "GE",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "DE",
        arrayItem: true,
        country: 'Germany',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>8</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Cisco, Huawei, Palantir</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "DE",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "DE",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "GH",
        arrayItem: true,
        country: 'Ghana',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>110</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        chinese: true,
        mapData: {
            "id": "GH",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "GH",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "HK",
        arrayItem: true,
        country: 'Hong Kong',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Bosch, Huawei</strong></p></div>",
        facial: true,
        chinese: true,
        mapData: {
            "id": "HK",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "HK",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "IN",
        arrayItem: true,
        country: 'India',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>4</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>ADRIN, Hikvision, IBM, Infinova, Microsoft, NEC</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "IN",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "IN",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "ID",
        arrayItem: true,
        country: 'Indonesia',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>26</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, NEC, PT Industri Telekomunikasi Indonesia</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "ID",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "ID",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "IR",
        arrayItem: true,
        country: 'Iran',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>18</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "IR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "IR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "IQ",
        arrayItem: true,
        country: 'Iraq',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>32</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "IQ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "IQ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "IL",
        arrayItem: true,
        country: 'Israel',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>17</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>AnyVision, BriefCam, Elbit, IBM, NICE, Verint</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        us: true,
        mapData: {
            "id": "IL",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "IL",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "IT",
        arrayItem: true,
        country: 'Italy',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>11</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        chinese: true,
        mapData: {
            "id": "IT",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "IT",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CI",
        arrayItem: true,
        country: 'Ivory Coast',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>82</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        chinese: true,
        mapData: {
            "id": "CI",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CI",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "JP",
        arrayItem: true,
        country: 'Japan',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>9</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, NEC</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "JP",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "JP",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "KZ",
        arrayItem: true,
        country: 'Kazakhstan',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>64</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Analytical Business Solutions, Huawei, Speech Technology Center</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "KZ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "KZ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "KE",
        arrayItem: true,
        country: 'Kenya',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>69</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, NEC, Safaricom</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "KE",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "KE",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "KG",
        arrayItem: true,
        country: 'Kyrgyzstan',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>118</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "KG",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "KG",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "LA",
        arrayItem: true,
        country: 'Laos',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "LA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "LA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "LB",
        arrayItem: true,
        country: 'Lebanon',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>52</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Crestron, Guardia</strong></p></div>",
        city: true,
        policing: true,
        us: true,
        mapData: {
            "id": "LB",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "LB",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MY",
        arrayItem: true,
        country: 'Malaysia',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>49</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, NEC, Yitu</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "MY",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MY",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MT",
        arrayItem: true,
        country: 'Malta',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>128</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "MT",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MT",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MU",
        arrayItem: true,
        country: 'Mauritius',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>141</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "MU",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MU",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MX",
        arrayItem: true,
        country: 'Mexico',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>31</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Cisco, Dahua, Infinova, Telmex, Thales</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "MX",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MX",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MN",
        arrayItem: true,
        country: 'Mongolia',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>122</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Dahua, SenseTime</strong></p></div>",
        facial: true,
        chinese: true,
        mapData: {
            "id": "MN",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MN",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "MA",
        arrayItem: true,
        country: 'Morocco',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>47</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>BAE, Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "MA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "MA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "NA",
        arrayItem: true,
        country: 'Namibia',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>89</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Otesa</strong></p></div>",
        facial: true,
        policing: true,
        mapData: {
            "id": "NA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "NA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "NL",
        arrayItem: true,
        country: 'Netherlands',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>21</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, IDEMIA</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "NL",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "NL",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "NZ",
        arrayItem: true,
        country: 'New Zealand',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>56</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Palantir</strong></p></div>",
        facial: true,
        policing: true,
        us: true,
        mapData: {
            "id": "NZ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "NZ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "NG",
        arrayItem: true,
        country: 'Nigeria',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>57</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        policing: true,
        chinese: true,
        mapData: {
            "id": "NG",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "NG",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "OM",
        arrayItem: true,
        country: 'Oman',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>30</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>BAE, Huawei, Idemia</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "OM",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "OM",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "PK",
        arrayItem: true,
        country: 'Pakistan',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>20</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "PK",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "PK",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "PA",
        arrayItem: true,
        country: 'Panama',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>FaceFirst, Huawei, Infinova</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "PA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "PA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "PH",
        arrayItem: true,
        country: 'Philippines',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>46</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Boeing, CITCC, IBM, Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "PH",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "PH",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "QA",
        arrayItem: true,
        country: 'Qatar',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>BAE, Orange</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        mapData: {
            "id": "QA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "QA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "RO",
        arrayItem: true,
        country: 'Romania',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>40</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Cisco, Telekom Romania, ZTE</strong></p></div>",
        city: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "RO",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "RO",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "RU",
        arrayItem: true,
        country: 'Russia',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>6</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Analytical Business Solutions, Cisco, Huawei, NtechLab, Speech Technology Center</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "RU",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "RU",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "RW",
        arrayItem: true,
        country: 'Rwanda',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>119</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        chinese: true,
        mapData: {
            "id": "RW",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "RW",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "SA",
        arrayItem: true,
        country: 'Saudi Arabia',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>3</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Briefcam, Gatekeeper, Hikvision, Huawei, Hugslock, IBM, NEC</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "SA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "SA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "RS",
        arrayItem: true,
        country: 'Serbia',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>73</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "RS",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "RS",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "SG",
        arrayItem: true,
        country: 'Singapore',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>22</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Accenture, AGT, Airbus, Dassault, Huawei, NEC, Tascent, Yitu</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "SG",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "SG",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "ZA",
        arrayItem: true,
        country: 'South Africa',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>48</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "ZA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "ZA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "KR",
        arrayItem: true,
        country: 'South Korea',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>10</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Axis, IBM, Korea Telecom, LG Uplus, SK Telecom</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        us: true,
        mapData: {
            "id": "KR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "KR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "ES",
        arrayItem: true,
        country: 'Spain',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>16</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Herta, Huawei, IBMN, SICE</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "ES",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "ES",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "CH",
        arrayItem: true,
        country: 'Switzerland',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>38</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Ekin</strong></p></div>",
        city: true,
        facial: true,
        mapData: {
            "id": "CH",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "CH",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "TW",
        arrayItem: true,
        country: 'Taiwan',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>23</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>No</strong></p><p>Relevant Companies: <strong>Gorilla, Lilin, NEC</strong></p></div>",
        facial: true,
        mapData: {
            "id": "TW",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "TW",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "TJ",
        arrayItem: true,
        country: 'Tajikistan',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "TJ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "TJ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "TH",
        arrayItem: true,
        country: 'Thailand',
        description: "<div class='description'><p>Region: <strong>East Asia and Pacific</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>29</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, Megvii, Panasonic, ZTE</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "TH",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "TH",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "TR",
        arrayItem: true,
        country: 'Turkey',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>15</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Avigilon, Dahua, HAVESLAN, Infinova</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "TR",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "TR",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "UG",
        arrayItem: true,
        country: 'Uganda',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>94</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "UG",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "UG",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "UA",
        arrayItem: true,
        country: 'Ukraine',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Electoral Democracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>39</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, Huawei, Microsoft</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "UA",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "UA",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "AE",
        arrayItem: true,
        country: 'United Arab Emirates',
        description: "<div class='description'><p>Region: <strong>Middle East and North Africa</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>BAE, BriefCam, Hikvision, Huawei, IBM, NEC</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "AE",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "AE",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "GB",
        arrayItem: true,
        country: 'United Kingdom',
        description: "<div class='description'><p>Region: <strong>Europe</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>7</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Hikvision, NEC, Palantir</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "GB",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "GB",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "US",
        arrayItem: true,
        country: 'United States',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>Free</strong></p><p>Military expenditures global ranking: <strong>1</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Mult; Amazon, Avigilon, Hikvision, IBM, Infinova, Palantir, Pelco, PredPol</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "US",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "US",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "UY",
        arrayItem: true,
        country: 'Uruguay',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Liberal Democracy</strong></p><p>Freedom on the net status: <strong>N/A</strong></p><p>Military expenditures global ranking: <strong>68</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>Yes</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Palantir, Herta, ZTE</strong></p></div>",
        city: true,
        facial: true,
        policing: true,
        chinese: true,
        us: true,
        mapData: {
            "id": "UY",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "UY",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "UZ",
        arrayItem: true,
        country: 'Uzbekistan',
        description: "<div class='description'><p>Region: <strong>South and Central Asia</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Relevant Companies: <strong>Huawei, Infinova, Speech Technology Center</strong></p></div>",
        city: true,
        facial: true,
        chinese: true,
        mapData: {
            "id": "UZ",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "UZ",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "VE",
        arrayItem: true,
        country: 'Venezuela',
        description: "<div class='description'><p>Region: <strong>Western Hemisphere</strong></p><p>Political Regime Type: <strong>Closed Autocracy</strong></p><p>Freedom on the net status: <strong>Not Free</strong></p><p>Military expenditures global ranking: <strong>N/A</strong></p><p>China Belt and Road Initiative: <strong>Yes</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Venezuela Companies: <strong>CEIEC, Huawei, ZTE</strong></p></div>",
        facial: true,
        chinese: true,
        mapData: {
            "id": "VE",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "VE",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "ZM",
        arrayItem: true,
        country: 'Zambia',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>98</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Venezuela Companies: <strong>Hikvision, Huawei, ZTE</strong></p></div>",
        facial: true,
        chinese: true,
        mapData: {
            "id": "ZM",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "ZM",
            settings: { fill: trackedCountry }
        }
    },
    {
        id: "ZW",
        arrayItem: true,
        country: 'Zimbabwe',
        description: "<div class='description'><p>Region: <strong>Africa</strong></p><p>Political Regime Type: <strong>Electoral Autocracy</strong></p><p>Freedom on the net status: <strong>Partly Free</strong></p><p>Military expenditures global ranking: <strong>91</strong></p><p>China Belt and Road Initiative: <strong>No</strong></p><p>U.S. AI Tech? <strong>No</strong></p><p>China AI Tech? <strong>Yes</strong></p><p>Venezuela Companies: <strong>CloudWalk, Hikvision, Huawei</strong></p></div>",
        facial: true,
        policing: true,
        chinese: true,
        mapData: {
            "id": "ZW",
            settings: { fill: trackedCountry }
        },
        inactiveMapData: {
            "id": "ZW",
            settings: { fill: trackedCountry }
        }
    },
]

var mapDataArray = dataArray;

function changeButtonOnClick(event) {
    var elList = document.querySelectorAll('.pub-type-label');
    elList.forEach(el => el.classList.remove('active'));
    event.currentTarget.parentElement.classList.add('active');
}

function callMap() {

    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    var root = am5.Root.new("chartdiv");

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
        am5themes_Animated.new(root)
    ]);

    // Create the map chart
    // https://www.amcharts.com/docs/v5/charts/map-chart/
    var chart = root.container.children.push(
        am5map.MapChart.new(root, {
            panX: "none",
            panY: "none",
            wheelX: "none",
            wheelY: "none",
            projection: am5map.geoMercator(),
            homeZoomLevel: 2,
            homeGeoPoint: { longitude: 0, latitude: 0 }
        })
    );
    // adding the zoom controls and making them teal    
    const zoomControl = chart.set("zoomControl", am5map.ZoomControl.new(root, {}));
    const zoomButtons = ['minusButton', 'plusButton'];

    zoomButtons.forEach((button) => {
        zoomControl[button].get('background').setAll({
            fill: am5.color(0x072a42)
        });
        zoomControl[button].get('background').states.create('hover', {}).setAll({
            fill: am5.color(0x000000)
        });
    });

    // Create series for background fill
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
    var backgroundSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {}));
    backgroundSeries.mapPolygons.template.setAll({
        fill: am5.color("#b0bac8"),
        fillOpacity: 1,
        strokeOpacity: 0
    });

    // Add background polygon
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
    backgroundSeries.data.push({
        geometry: am5map.getGeoRectangle(90, 180, -90, -180)
    });

    // Create main polygon series for countries
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
    var polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            exclude: ["AQ"]
        })
    );

    //country list country code
    var countryAbbreviations = ["AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AG", "AR", "AM", "AW", "AU", "AT", "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BM", "BT", "BO", "BA", "BW", "BV", "BR", "VG", "IO", "BN", "BG", "BF", "BI", "KH", "CM", "CA", "CV", "KY", "CF", "TD", "CL", "CN", "HK", "MO", "CX", "CC", "CO", "KM", "CG", "CD", "CK", "CR", "CI", "HR", "CU", "CY", "CZ", "DK", "DJ", "DM", "DO", "EC", "EG", "SV", "GQ", "ER", "EE", "ET", "FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF", "GA", "GM", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GG", "GN", "GW", "GY", "HT", "HM", "VA", "HN", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KI", "KP", "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU", "MK", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MQ", "MR", "MU", "YT", "MX", "FM", "MD", "MC", "MN", "ME", "MA", "MZ", "MM", "NA", "NR", "NP", "NL", "NZ", "NI", "NE", "NG", "MP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL", "PT", "PR", "QA", "RE", "RO", "RU", "RW", "KN", "LC", "VC", "WS", "SM", "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SK", "SI", "SB", "SO", "ZA", "GS", "SS", "ES", "LK", "SD", "SR", "SJ", "SZ", "SE", "CH", "SY", "TW", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "GB", "US", "UY", "UZ", "VU", "VE", "VN", "VI", "EH", "YE", "ZM", "ZW"]

    // Configure series
    polygonSeries.mapPolygons.template.setAll({
        tooltipText: "{name}",
        interactive: true,
        fill: am5.color("#e6e7ed"),
        templateField: "settings"
    });

    polygonSeries.events.on("datavalidated", function () {
        chart.goHome();
    });

    polygonSeries.mapPolygons.template.states.create("active", {
        fill: clickedCountry
    });

    function closeButton() {
        // close button in info
        document.querySelector("#closeInfo").onclick = function (e) {
            document.getElementById("info").classList.remove("active");
            countryAbbreviations.forEach(value => {
                var countryDataItem = polygonSeries.getDataItemById(value);
                var polygon = countryDataItem.get("mapPolygon");
                polygon.states.apply("default");
            });
            var elList = document.querySelectorAll('#protestTable tr.primary');
            elList.forEach(el => {
                el.classList.remove("hidden--new")
            });
        };
    }

    function resetSelect() {
        document.getElementById("surveillance-countries").value = "reset";
    }

    document.getElementById("surveillance-countries").onchange = function (ev) { changeCountry(ev) };

    function changeCountry(ev) {
        var results = ev.target.value;
        var info = document.getElementById("info");
        var html = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'></span>X</div>";
        // only look into the prefiltered version -- we are also using this so certain actions (activating info box, activating country, filtering table) only happen for a 'positive' result
        for (var e in mapDataArray) {
            if (mapDataArray[e].id == results) {
                // making info box visible
                document.getElementById("info").classList.add("active");

                //gathering data
                html += "<h3 class='country'>" + mapDataArray[e].country + "</h3>";
                if (mapDataArray[e].description) {
                    html += mapDataArray[e].description;
                }
                else {
                    html += "<div class='description'><p><i>No description provided.</i></p></div>";
                }

                // making clicked country active color
                countryAbbreviations.forEach(value => {
                    var countryDataItem = polygonSeries.getDataItemById(value);
                    var polygon = countryDataItem.get("mapPolygon");
                    if (value !== results) { polygon.states.apply("default"); }
                    else { polygon.states.apply("active"); }
                });
            }
        }
        info.innerHTML = html;

        // close button in info
        closeButton();
    }

    polygonSeries.mapPolygons.template.events.on("click", function (ev) {
        var data = ev.target.dataItem.dataContext;
        var info = document.getElementById("info");
        var html = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'></span>X</div>";
        // only look into the prefiltered version -- we are also using this so certain actions (activating info box, activating country, filtering table) only happen for a 'positive' result
        for (var e in mapDataArray) {
            if (mapDataArray[e].country == data.name) {
                // making info box visible
                document.getElementById("info").classList.add("active");

                //gathering data
                html += "<h3 class='country'>" + mapDataArray[e].country + "</h3>";
                if (mapDataArray[e].description) {
                    html += mapDataArray[e].description;
                }
                else {
                    html += "<div class='description'><p><i>No description provided.</i></p></div>";
                }

                // making clicked country active color
                countryAbbreviations.forEach(value => {
                    var countryDataItem = polygonSeries.getDataItemById(value);
                    var polygon = countryDataItem.get("mapPolygon");
                    if (value !== data.id) { polygon.states.apply("default"); }
                    else { polygon.states.apply("active"); }
                });
            }
        }
        info.innerHTML = html;

        // close button in info
        closeButton();
        resetSelect();
    });

    //reconfigure based on filters

    function buildMapFromButton(inactiveResults, results, value) {
        // create array that is only the negative results inactiveMapData
        var inactiveMapDataArray = [];
        var index = 0;
        for (var e in inactiveResults) {
            inactiveMapDataArray[index] = inactiveResults[e].inactiveMapData;
            index++
        };
        var fillColor = trackedCountry
        if (value == "city") { fillColor = activeCountrySmartCity }
        else if (value == "facial") { fillColor = activeCountryFacialRecognition }
        else if (value == "policing") { fillColor = activeCountrySmartPolicing }
        else if (value == "us") { fillColor = activeCountryUSTech }
        else if (value == "chinese") { fillColor = activeCountryChinaTech }
        // push to new polygonSeries the array with positive results as normal
        var activeMapColors = []
        for (var e in results) {
            activeMapColors.push(results[e].mapData);
        }
        for (var e in activeMapColors) {
            activeMapColors[e].settings.fill = fillColor;
        }
        // combine the inactive array for light color inactive countries and active array for bright active countries
        const fullMap = inactiveMapDataArray.concat(activeMapColors);
        polygonSeries.data.setAll(fullMap);
    }

    //reset
    document.querySelector("#radio-all").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.arrayItem);
        // push to new polygonSeries the array with positive results as normal
        var newMapColors = []
        for (var e in results) {
            newMapColors.push(results[e].mapData);
        }
        for (var e in newMapColors) {
            newMapColors[e].settings.fill = trackedCountry;
        }
        polygonSeries.data.setAll(newMapColors);
        resetSelect();
    };
    //Smart city 
    document.querySelector("#radio-city").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.city);
        var inactiveResults = dataArray.filter(data => !data.city);
        buildMapFromButton(inactiveResults, results, "city");
        //info box
        var info = document.getElementById("info");
        info.classList.add("active");
        info.innerHTML = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'>X</span></div><h3 class='smart-city'>Smart City</h3><div class='description'><p>Cities with sensors that transmit real-time data to facilitate service delivery, city management, and public safety. Often referred to as “safe cities,” they incorporate sensors, facial recognition cameras, and police body cameras connected to intelligent command centers to prevent crime, ensure public safety, and respond to emergencies. Only platforms with a clear public safety focus are incorporated in the index.</p></div>";

        // close button in info
        closeButton();
        resetSelect();
    };
    //facial recognition
    document.querySelector("#radio-facial").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.facial);
        var inactiveResults = dataArray.filter(data => !data.facial);
        buildMapFromButton(inactiveResults, results, "facial");
        //info box
        var info = document.getElementById("info");
        info.classList.add("active");
        info.innerHTML = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'>X</span></div><h3 class='facial-recognition'>Facial Recognition Systems</h3><div class='description'><p>Biometric technology that uses cameras (still images or video) to match stored or live footage of individuals with images from databases. Not all systems focus on database matching; some systems assess aggregate demographic trends or conduct broader sentiment analysis via facial recognition crowd scanning.</p></div>";

        // close button in info
        closeButton();
        resetSelect();
    };
    //smart policing
    document.querySelector("#radio-police").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.policing);
        var inactiveResults = dataArray.filter(data => !data.policing);
        buildMapFromButton(inactiveResults, results, "policing");
        //info box
        var info = document.getElementById("info");
        info.classList.add("active");
        info.innerHTML = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'>X</span></div><h3 class='smart-policing'>Smart Policing</h3><div class='description'><p>Data-driven analytic technology used to facilitate investigations and police response; some systems incorporate algorithmic analysis to make predictions about future crimes.</p></div>";

        // close button in info
        closeButton();
        resetSelect();
    };
    //chinese tech
    document.querySelector("#radio-chinese").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.chinese);
        var inactiveResults = dataArray.filter(data => !data.chinese);
        buildMapFromButton(inactiveResults, results, "chinese");
        //info box
        var info = document.getElementById("info");
        info.classList.add("active");
        info.innerHTML = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'>X</span></div><h3 class='chinese-tech'>Chinese Technology</h3><div class='description'><p>These countries use Chinese companies to supply their AI surveillance technology.</p></div>";

        // close button in info
        closeButton();
        resetSelect();
    };
    //us tech
    document.querySelector("#radio-us").onclick = function (e) {
        //create array with positive results
        const results = dataArray.filter(data => data.us);
        var inactiveResults = dataArray.filter(data => !data.us);
        buildMapFromButton(inactiveResults, results, "us");
        //info box
        var info = document.getElementById("info");
        info.classList.add("active");
        info.innerHTML = "<div class='close-panel' id='closeInfo'><span class='ceip-icon icon-cancel-circle'>X</span></div><h3 class='us-tech'>U.S. Technology</h3><div class='description'><p>These countries use U.S. companies to supply their AI surveillance technology.</p></div>";

        // close button in info
        closeButton();
        resetSelect();
    };

    // this needs to happen at the end after all the click events are declared
    var mapColors = []
    for (var e in mapDataArray) {
        mapColors.push(mapDataArray[e].mapData);
    }
    polygonSeries.data.setAll(mapColors);

    // Make stuff animate on load
    chart.appear(1000, 100);
};

</script>

<style lang="scss" scoped>
$gutter: 30px;
$site-width: 1000px;

/* local variables */
$primary-light-blue: #3183b1;
$primary-dark-blue: #072a42;
$active-red: #EF4136;
$active-blue: #00AEEF;
$active-yellow: #FBB042;
$active-purple: #81215F;
$active-teal: #00A79D;
$active-selected: #000000;
$medium-gray: #e6e7e8;
$black: #000;
$white: #fff;

$roman-normal-book: "Frutiger Neue LT W06 Book", Arial, sans-serif;
$roman-italic-book: "Frutiger Neue LT W06 Book It", Arial, sans-serif;
$roman-normal-bold: "Frutiger Neue LT W06 Bold", "Arial Black", Gadget, sans-serif;

/*layout basics*/
.foreground {
    position: relative;
    margin: 0 auto;
    box-sizing: content-box;
    max-width: $site-width;
    padding-left: calc($gutter / 2);
    padding-right: calc($gutter / 2);
}

.section {
    display: block;
    clear: both;
    margin-top: $gutter;
    margin-bottom: $gutter;
}

:deep(.hidden) {
    display: none;
}

.zone-title {
    background-color: $medium-gray;
    padding: calc($gutter * 1.5) 0;

    h2 {
        color: $primary-dark-blue;
        font-family: $roman-normal-bold;
        margin: $gutter 0;
    }

    p {
        font-family: $roman-normal-book;
    }
}

.filters {
    font-size: 1rem;
    margin: $gutter auto;
    width: 90%;

    .title {
        background-color: $primary-dark-blue;
        float: left;
        padding: calc($gutter / 2);
        width: auto;

        span {
            color: $white;
            font-family: $roman-normal-bold;
            font-size: 1rem;
            line-height: 0.8em;
        }
    }

    form {
        float: left;
        margin-bottom: 0;

        fieldset {
            padding-left: calc($gutter / 2);

            label {
                cursor: pointer;
                float: left;
                margin: 0 calc($gutter / 5);
                outline: 1px solid $black;
                /*using this instead of border so I can repurpose border-left*/
                -moz-outline: 1px solid $black;
                padding: 5px;

                &.active {
                    color: $white;

                    &.reset {
                        color: $black
                    }
                }

                input {
                    display: none
                }

                span.name {
                    font-family: $roman-normal-book;
                    font-size: 0.8rem;
                    padding-right: 5px;
                }

                &:hover {
                    background-color: #e6e7ed;
                }

                &#smartCity {
                    border-left: $active-red 10px solid;

                    &.active {
                        background-color: $active-red;
                    }
                }

                &#facialRecognition {
                    border-left: $active-blue 10px solid;

                    &.active {
                        background-color: $active-blue;
                    }
                }

                &#smartPolicing {
                    border-left: $active-yellow 10px solid;

                    &.active {
                        background-color: $active-yellow;
                    }
                }

                &#USTech {
                    border-left: $active-purple 10px solid;

                    &.active {
                        background-color: $active-purple;
                    }
                }

                &#ChineseTech {
                    border-left: $active-teal 10px solid;

                    &.active {
                        background-color: $active-teal;
                    }
                }
            }

        }
    }
}

.map {
    margin: $gutter 0;
    position: relative;
}

#countrySelect {
    position: absolute;
    left: 6%;
    top: 10px;
}

select {
    border: 1px solid #ccc;
    background: white;
    /*webkit browsers */
    -webkit-appearance: auto;
    /*Firefox */
    -moz-appearance: auto;
    /* modern browsers */
    appearance: auto;
}

:deep(#info) {
    display: none;

    &.active {
        background-color: rgba(255, 255, 255, 0.8);
        border: 1px solid $black;
        position: absolute;
        display: block;
        width: 20%;
        height: 100%;
        top: 0;
        right: 5%;
        overflow-y: scroll;

        h3 {
            color: $white;
            display: block;
            font-family: $roman-normal-bold;
            font-size: 0.9rem;
            padding: 5px 5px 5px 35px;
            width: 100%;

            &.smart-city {
                background-color: $active-red;
            }

            &.facial-recognition {
                background-color: $active-blue;
            }

            &.smart-policing {
                background-color: $active-yellow;
            }

            &.us-tech {
                background-color: $active-purple;
            }

            &.chinese-tech {
                background-color: $active-teal;
            }

            &.country {
                background-color: $active-selected;
            }
        }

        .description {
            font-family: $roman-normal-book;
            font-size: .8rem;
            padding: 5px;

            p {
                margin-bottom: 15px;
            }

            strong {
                display: block;
            }
        }

    }

    .close-panel {
        color: $white;
        cursor: pointer;
        font-family: $roman-normal-bold;
        font-size: 1.1rem;
        font-weight: normal;
        top: 0;
        left: -15px;
        position: absolute;
        text-transform: uppercase;

        &:after {
            border: none;
        }

        .icon-cancel-circle {
            padding-left: 1em;
        }
    }
}

#chartdiv {
    float: none;
    margin: 0 auto;
    max-width: 1600px;
    height: 650px;
}

.learn-more {

    p,
    li {
        font-family: $roman-normal-book;
    }

    .button-big {
        margin: $gutter auto calc($gutter * 4) auto;
        width: 20%;
    }
}
</style>